import * as React from "react";

import {Form, FormListener} from "../form/Form";
import {SelectInput} from "../form/SelectInput";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";
import {Alert} from "../form/Alert";
import {Collapsible} from "../Collapsible";
import {AccountBalanceResult, TransactionResult, TransferRequest, TransferRequestSubtype, TransferRequestType} from "../../http/protocol";
import { WalletService } from "../../services/WalletService";
import { ErrorModal } from "../../util/ErrorModal";
import { ConfirmModal } from "../../util/ConfirmModal";

interface Props {
    accounts? : AccountBalanceResult[];
    //transfer : (transferRequest : TransferRequest) => Promise<TransactionResult>;
    service : WalletService;
    onTransferComplete : ( result : TransactionResult) => void;
}
interface State {
    transactionForm? : TransferRequest;
    validationMap? : any;
    showModal?:boolean;
    showErrorModal?:boolean;
    showErrorMessage?:string;
}

export class UserTransactionPanel extends React.Component<Props, State> implements FormListener<TransferRequest> {
    constructor(props : Props) {
        super(props);
        this.state = { transactionForm : {}, validationMap : {}};
    }

    onSubmit() : Promise<any> | undefined {
        let currentAccount = this.getAccounts();
        let transactionForm = this.state.transactionForm;
        if(transactionForm && currentAccount) {
            let current = transactionForm.accountId;
            currentAccount.forEach((account,index)=>{
                let currentId = Number(current);
                let accountId = Number(account.accountId);
                if(currentId === accountId){
                    if(account.accountAttributes!==undefined && account.accountAttributes["ROLE"]==="BONUS"){
                        return this.transferBonus(transactionForm!);
                    }else{
                        return this.transferMain(transactionForm!);
                    }
                }
            })
        }
        return undefined;
    }

    closeModal(){
        this.setState({showErrorModal:false})
    }

    transferBonus(transactionForm?: TransferRequest | undefined){
        return this.props.service.transferBonus(transactionForm!).then((tr)=>{
            this.setState({transactionForm : Object.assign({},this.state.transactionForm, { amount : "", comment : ""}), showModal:true})
            this.props.onTransferComplete(tr);
        }).catch(err=>{
            this.setState({transactionForm : Object.assign({},this.state.transactionForm, { amount : "", comment : ""}), showErrorModal:true, showErrorMessage:err.message})
            throw err.message;
        });
    }

    transferMain(transactionForm?: TransferRequest | undefined){
        return this.props.service.transfer(transactionForm!).then((tr)=>{
            this.setState({transactionForm : Object.assign({},this.state.transactionForm, { amount : "", comment : ""}), showModal:true})
            this.props.onTransferComplete(tr);
        }).catch(err=>{
            this.setState({transactionForm : Object.assign({},this.state.transactionForm, { amount : "", comment : ""}), showErrorModal:true, showErrorMessage:err.message})
            throw err.message;
        });
    }

    formDidUpdate(formModel: TransferRequest, validationMap?: any) {
        this.setState({transactionForm : formModel, validationMap : validationMap});
    }

    getAccounts() {
        return this.props.accounts;
    }
    toDisplayValue(a : AccountBalanceResult){
        const amount = a.balance && a.balance.amount && a.balance.amount.toLocaleString("en",{maximumFractionDigits:8, minimumFractionDigits:2});
        if(!a.accountAttributes  || !a.balance) {
            return "N/A";
        }
        return a.accountAttributes["ROLE"] + "  " + amount + " " + a.balance.currencyCode;
    }
    getCurrentAccount() : AccountBalanceResult | undefined{
        if(!this.state.transactionForm || !this.props.accounts) {
            return;
        }
        let current = this.state.transactionForm.accountId;
        return this.props.accounts.find(x=> x.accountId===current);
    }

    getTransactionTypes(): TransferRequestType[]{
        let array = Object.values(TransferRequestType).sort();

        const newArr: TransferRequestType[] = array.filter((element) => {
            //Hide elements of TransferRequestSubtype
            return element;
        });

        return newArr;
    }

    getSubTypes(): TransferRequestSubtype[]{
        let array = Object.values(TransferRequestSubtype).sort();

        const newArr: TransferRequestSubtype[] = array.filter((element) => {
            //Hide elements of TransferRequestSubtype
            return element !== TransferRequestSubtype.REBATE;
        });

        return newArr;
    }

    getForm() {
        let accounts = this.getAccounts();
        if(!accounts  || accounts.length === 0 || !this.state.transactionForm) {
            return (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <Alert text={"User do not have any accounts"} type="info" />
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <Form className="manual-adjustment-form container-fluid" formListener={this} validationMap={this.state.validationMap} modelObject={this.state.transactionForm}>
                <div className="row">
                    <div className="col-sm-6">
                        <label>Transaction Type</label>
                        <SelectInput optional={true} className="form-control" model="type" values={this.getTransactionTypes()} required={true}/>
                    </div>
                    <div className="col-sm-6">
                        <label>Amount</label>
                        <FormInput className="form-control"  model="amount" type="float" validators={[Validators.required(), Validators.number()]}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <label>{ this.state.transactionForm.type === "CREDIT" ? "To" : "From"} Account</label>
                        <SelectInput className="form-control" model="accountId" values={accounts} displayValue={this.toDisplayValue} optionModelValue={ (a : AccountBalanceResult)=> { return a.accountId; }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <label>SubType</label>
                        <SelectInput optional={true} values={this.getSubTypes()} className="form-control" model="subtype" type="text" validators={[Validators.required()]} required={true}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-8">
                        <label>Comment</label>
                        <FormInput type="text" className="form-control" model="comment" validators={[Validators.required(), Validators.textInput()]}/>
                    </div>
                    <div className="col-sm-4">
                        <label>&nbsp;</label>
                        <Submit className="btn btn-primary btn-block">Transfer</Submit>
                    </div>
                </div>  
            </Form>
        );
    }

    render() {
        return (
            <Collapsible title="Manual Balance Adjustment" collapsed={true}>
                <div>
                    {(this.state.showModal === true) && (
                        <ConfirmModal
                            show={this.state.showModal}
                            okLabel={"Close"}
                            heading={"OMG, we did it!"}
                            description={"Transfer successful!"}
                            okClassName={"btn btn-primary"}
                            hideCancelButton={true}
                            onOk={()=>{
                                this.setState({showModal: false});
                            }}
                            onCancel={()=>{ this.setState({showModal: false})}}
                            descriptionAlert={true}
                    />
                    )}
                    {this.state.showErrorModal === true && (
                        <ErrorModal
                                show={this.state.showErrorModal}
                                hideCancelButton={true}
                                hideOkButton={true}
                                heading="Oops, something went bonker!"
                                description={this.state.showErrorMessage ||`Oops, something went bonker!`}
                                okLabel="OK"
                                onOk={
                                    this.closeModal.bind(this)
                                }
                                onCancel={this.closeModal.bind(this)}
                        />
                    )}
                </div>
                {this.getForm()}
            </Collapsible>
        );
    }
}